import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import './HorizonFeaturesTab.css';
const HorizonFeaturesTab = () => {
    const { t } = useTranslation();
    const features = [
        {
            id: 'mooninfo',
            image: '/images/horizon/moonview.png',
            imagePosition: 'left',
            title: t('horizon.mooninfo.title', 'Mooninfo'),
            items: [
                t('horizon.mooninfo.distance', 'S: Current visible moon distance (100% is the closest the moon gets to earth)'),
                t('horizon.mooninfo.illumination', 'I: Illumination - shows how much of the visible moon is illuminated'),
                t('horizon.mooninfo.rise', '3:45 NE: Time with compass direction where the moon will rise'),
                t('horizon.mooninfo.set', '6:47 NW: Time with compass direction where the moon will set'),
                t('horizon.mooninfo.age', '27d: Moon\'s age - days passed since New Moon'),
            ],
        },
        {
            id: 'forecast',
            image: '/images/horizon/forecast.png',
            imagePosition: 'right',
            title: t('horizon.forecast.title', 'Weather Forecast'),
            items: [
                t('horizon.forecast.pages', '1/2: Available pages - switches automatically after ~4 seconds to the next two days'),
                t('horizon.forecast.day', '"Sa/So": Day of the week'),
                t('horizon.forecast.precip', '"14%": Precipitation chance (chance of rain)'),
                t('horizon.forecast.temp', '"59-69°F": Lowest to highest temperature'),
            ],
        },
        {
            id: 'bodystatus',
            image: '/images/horizon/bodystatus.png',
            imagePosition: 'left',
            title: t('horizon.bodystatus.title', 'Body Status'),
            items: [
                t('horizon.bodystatus.outer', 'Outer ring: Available body battery for this day'),
                t('horizon.bodystatus.inner', 'Inner ring: Current stress level'),
                t('horizon.bodystatus.hr', '40: Average resting heart rate of the last 7 days'),
            ],
        },
        {
            id: 'movegoals',
            image: '/images/horizon/movegoals.png',
            imagePosition: 'right',
            title: t('horizon.movegoals.title', 'Move Goals'),
            items: [
                t('horizon.movegoals.steps', 'Outer ring: Steps'),
                t('horizon.movegoals.calories', '2nd outer ring: Calories burned'),
                t('horizon.movegoals.floors', 'Middle ring: Floors climbed'),
                t('horizon.movegoals.activity', 'Inner ring: Activity minutes of the week'),
            ],
        },
        {
            id: 'charts',
            image: '/images/horizon/charts.png',
            imagePosition: 'left',
            title: t('horizon.charts.title', 'Charts'),
            items: [
                t('horizon.charts.left', 'Left value: Lowest value of the time period'),
                t('horizon.charts.right', 'Right value: Highest value'),
                t('horizon.charts.xaxis', 'Lines on the X axis: 20 minutes each'),
                t('horizon.charts.direction', 'Left to right → oldest to latest values'),
            ],
        },
        {
            id: 'arcslots',
            image: '/images/horizon/arcslots.png',
            imagePosition: 'right',
            title: t('horizon.arcslots.title', 'Arc Slots'),
            items: [
                t('horizon.arcslots.select', 'Select the values to be shown in the following options (Arcslot Top/Left/Right).'),
                t('horizon.arcslots.icon', 'If you only select an option for the top arcslot and leave the other two empty, an icon will be displayed for the top option.'),
            ],
        },
        {
            id: 'tides',
            image: '/images/horizon/tides.png',
            imagePosition: 'left',
            title: t('horizon.tides.title', 'Tides'),
            items: [
                t('horizon.tides.height', '-0.1 / 0.1: Lowest / highest height of the tide'),
                t('horizon.tides.hours', '0  3  6  9  12: Hour (the most left value is always closest to now)'),
                t('horizon.tides.bar', 'Yellow bar: Highest / lowest value in the next 0-48 hours'),
                t('horizon.tides.distance', '454 km: Distance to the nearest measuring station'),
            ],
        },
        {
            id: 'airquality',
            image: '/images/horizon/aq.png',
            imagePosition: 'right',
            title: t('horizon.airquality.title', 'Air Quality'),
            items: [
                t('horizon.airquality.color', 'The color of the circles indicates the quality of the index.'),
                t('horizon.airquality.pm25', 'PM² = PM2.5'),
                t('horizon.airquality.pm10', 'PM = PM10'),
            ],
            link: {
                text: t('horizon.airquality.moreInfo', 'More information on Wikipedia'),
                url: 'https://en.wikipedia.org/wiki/Air_quality_index',
            },
        },
    ];
    return (_jsx("div", { className: "horizon-features-tab", children: features.map((feature) => (_jsxs("div", { className: `horizon-feature-row ${feature.imagePosition === 'right' ? 'image-right' : 'image-left'}`, children: [_jsx("div", { className: "horizon-feature-image", children: _jsx("img", { src: feature.image, alt: feature.title }) }), _jsxs("div", { className: "horizon-feature-text", children: [_jsx("h3", { children: feature.title }), _jsx("ul", { children: feature.items.map((item, idx) => (_jsx("li", { children: item }, idx))) }), feature.link && (_jsxs("a", { href: feature.link.url, target: "_blank", rel: "noopener noreferrer", className: "horizon-feature-link", children: [feature.link.text, " \u2192"] }))] })] }, feature.id))) }));
};
export default HorizonFeaturesTab;
